import { render, staticRenderFns } from "./Bubble.vue?vue&type=template&id=172abc12&scoped=true&"
import script from "./Bubble.vue?vue&type=script&lang=js&"
export * from "./Bubble.vue?vue&type=script&lang=js&"
import style0 from "./Bubble.vue?vue&type=style&index=0&id=172abc12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172abc12",
  null
  
)

export default component.exports